/** @jsx h */
import { h } from 'preact'

const Packaging = ({ packagingList, connector = 'and' }) => {
  return (
    <span>
      <span class='Subheading'>
        {packagingList.slice(0, packagingList.length - 1).join(', ')}
      </span>
      {packagingList.length !== 1 &&
        <span> {connector} </span>}
      <span class='Subheading'>
        {packagingList[packagingList.length - 1]}
      </span>
    </span>
  )
}

export default Packaging
